import axios from "../../config/axios";
import rutasGenericas from "../../config/apiBase";

const apiSinBases = {
  modelo: "formulario",
  subirImagen,
  getImgsForm,
};

const clienteApi = rutasGenericas(apiSinBases);

function subirImagen(img) {
  return axios.post(`${axios.defaults.baseURL}/api/imagen/`, img);
}

function getImgsForm(params) {
  return axios.get(`${axios.defaults.baseURL}/api/imagen/form`, { params })
    .then(resp => resp.data);
}

export default clienteApi;
